import { initTitleLineRevealOnView } from '../parts/highlight-sweep';
initTitleLineRevealOnView('.block-contact-us__title', '.js--gradient-highlight-contact-us');
const SELECTORS = {
    card: '.block-contact-us__card',
    form: '.js-contact-form',
    success: '.js-contact-success',
    successTitle: '.js-contact-success-title',
};
const initContactUsSuccess = () => {
    document.addEventListener('wpcf7mailsent', (event) => {
        const target = event.target;
        if (!target)
            return;
        const card = target.closest(SELECTORS.card);
        if (!card)
            return;
        const form = card.querySelector(SELECTORS.form);
        const success = card.querySelector(SELECTORS.success);
        const successTitle = card.querySelector(SELECTORS.successTitle);
        const { detail } = event;
        const inputs = Array.isArray(detail?.inputs) ? detail.inputs : [];
        const firstName = inputs.find((input) => input.name === 'first-name')?.value ?? '';
        if (successTitle) {
            const template = successTitle.dataset.template ?? successTitle.textContent ?? '';
            successTitle.textContent = template.replace('{first_name}', firstName);
        }
        if (form)
            form.hidden = true;
        if (success)
            success.hidden = false;
    });
};
document.addEventListener('DOMContentLoaded', initContactUsSuccess);
if (window.acf) {
    window.acf.addAction?.('render_block_preview', initContactUsSuccess);
}
export default initContactUsSuccess;
